import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";

import {
  addMultipleCacheData,
  getCache,
  isTemplateExisits,
  useNonInitialEffect,
} from "../../../utils/commonFunctions";
import Config from "../../../config/app.config.json";
import { NLContentStrapi } from "../../../features/strapi/nutritionLabelSlice";
import { Box, CircularProgress } from "@mui/material";
import { getConfigKeys } from "../../../features/activation/activationSlice";

type Props = {
  NLContent?: any;
  plan: any;
  planPerLinesCost: any;
  minShipvalue: any;
  maxShipvalue: any;
  planCost?: any;
};
const NLCardComp = isTemplateExisits(Config.NutritionLabelPage.NLCard)
  ? require(`./${Config.NutritionLabelPage.NLCard.template}_NLCard`).default
  : null;

export const NLCard = (props: Props) => {
  const { plan, planPerLinesCost, minShipvalue, maxShipvalue, planCost } =
    props;

  const dispatch = useAppDispatch();
  const { configKeys } = useAppSelector((state: any) => state?.activation);
  const [cacheData, setCacheData] = useState<any>(null);
  const { nutritionLabelData } = useAppSelector(
    (state: any) => state?.strapi?.nutritionLabel || {}
  );

  useEffect(() => {
    if (!configKeys) {
      dispatch(getConfigKeys());
    }
  }, [configKeys]);
  useEffect(() => {
    getCache("NutritionLabel", NLContentStrapi, setCacheData, dispatch);
  }, []);
  useNonInitialEffect(() => {
    addMultipleCacheData("NutritionLabel", nutritionLabelData);
  }, [nutritionLabelData]);

  return (nutritionLabelData || cacheData && configKeys) ? (
    <NLCardComp
      NLContent={cacheData ? cacheData.NL_Data : nutritionLabelData.NL_Data}
      plan={plan}
      planPerLinesCost={planPerLinesCost}
      minShipvalue={minShipvalue}
      maxShipvalue={maxShipvalue}
      planCost={planCost}
    />
  ) : (
    <Box
      sx={{
        textAlign: "center",
        p: "10px",
      }}
    >
      <CircularProgress
        sx={{
          color: "var(--primary_color)",
        }}
      />
    </Box>
  );
};
